import { useEffect } from "react";
import styled from "styled-components";
import Box from "./Box";
import { BiCheckCircle, BiXCircle } from "react-icons/bi";

interface IProps {
  message?: string;
  active?: boolean;
  onHide: () => void;
  durations?: number;
  type?: "error" | "success";
}

const Toast = (props: IProps) => {
  const { message = "", active = false, onHide, durations = 1500, type = "success" } = props;

  useEffect(() => {
    if (active) {
      setTimeout(() => {
        onHide();
      }, durations);
    }
  }, [active, durations, onHide])

  return (
    <Container style={{ display: !active || !message ? "none" : "flex" }}>
      {/* <Overlay /> */}
      <StyledMessage>
        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
          {
            type === "success" ? (
              <BiCheckCircle color="#305B1F" size={32} />
              ) : (
              <BiXCircle color="#ED5F5A" size={32} />
              )
          }
          <Box color={type === "success" ? "#325E22" : "#e02d33"} fontSize={16} mt={1} textAlign="center">
            {message}
          </Box>
        </Box>
      </StyledMessage>
    </Container>
  )
}

export default Toast;

const Container = styled("div")({
  zIndex: 999,
  position: "absolute",
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  background: "transparent",
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
});

const StyledMessage = styled(Box)({
  display: "flex",
  padding: 20,
  backgroundColor: "#EAF7F1",
  borderRadius: 20,
  opacity: 0.9,
})